export async function GetAssignedTasksApi(positionId, perfCycleId) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/tasks/assigned/${positionId}?perfCycleId=${perfCycleId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = { success: false, message: "Error fetching assigned tasks" };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: "Error fetching assigned tasks" };
  }

  return res;
}
